import type { DrawerFooterFactory, IProps } from "./drawer-footer.types";
import classnames from "classnames";
import styles from "../drawer.module.scss";
import { componentWrapper } from "../../../utilities";
import { Box } from "../../box";
import { ModalFooterActions } from "../../modal/modal-footer/modal-footer-actions";

/**
 * The drawer's action row, below the scrolling body, divided from it by a border.
 */
const DrawerFooter = componentWrapper<DrawerFooterFactory, IProps>("DrawerFooter", ({ className, ...props }, ref) => {
    // Merged, not replaced: the footer's border lives on this class.
    return <Box ref={ref} className={classnames(styles["footer"], className)} {...props} />;
});

// The same right-aligned action row, Cancel and Done as Modal.Footer.Actions, so drawer and modal footers match.
DrawerFooter.Actions = ModalFooterActions;

export { DrawerFooter };
